var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"disabled":_vm.disabled,"size":"sm"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t('Component(Button):done-goto-next-step'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }